'use client';
import { FlashList } from '@shopify/flash-list';
import { X } from '@tamagui/lucide-icons';
import { useEffect, useRef, useState } from 'react';
import { Animated, Dimensions, Modal, Platform } from 'react-native';
import { Image, Text, View, XStack } from 'tamagui';
import Pagination from './pagination';

const screenWidth = Dimensions.get('window').width;

export function ImagePreview({ open, setOpen, index, imageUrls, onClose }) {
  const imageHeight = 500;
  const imageWidth = screenWidth - 20;

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const scrollX = useRef(new Animated.Value(0)).current;
  const [error, setError] = useState(false);
  const flatListRef = useRef(null);

  useEffect(() => {
    setCurrentImageIndex(index);
  }, [index]);

  const handleOnScroll = (event) => {
    Animated.event(
      [{ nativeEvent: { contentOffset: { x: scrollX } } }],
      { useNativeDriver: false }
    )(event);
  };

  const handleNext = () => {
    const nextIndex = currentImageIndex < imageUrls?.length - 1 ? currentImageIndex + 1 : 0;
    setCurrentImageIndex(nextIndex);
  };

  const handleBack = () => {
    const prevIndex = currentImageIndex > 0 ? currentImageIndex - 1 : imageUrls?.length - 1;
    setCurrentImageIndex(prevIndex);
  };

  const getItemLayout = (_data, index) => ({
    length: screenWidth,
    offset: screenWidth * index,
    index,
  });

  const renderItem = ({ item }) => {
    if (error) {
      return (
        <View
          style={{
            width: imageWidth,
            height: imageHeight,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f0f0f0',
          }}
        >
          <Text>Could not load image</Text>
        </View>
      );
    }

    return (
      <View width={screenWidth} justifyContent="center" alignItems="center">
        <Image
          width={imageWidth}
          height={imageHeight}
          resizeMode="contain"
          source={{ uri: item }}
          borderRadius={10}
          onError={() => {
            console.log('Error loading image:', item);
            setError(true);
          }}
        />
      </View>
    );
  };


  return (
    <Modal visible={open} transparent onRequestClose={onClose}>
      <View
        justifyContent="center"
        alignItems="center"
        backgroundColor="rgba(0, 0, 0, 0.8)"
        flex={1}
        alignContent="center"
      >
        {imageUrls?.length > 0 && (
          <FlashList
            ref={flatListRef}
            data={imageUrls.map((media) => media?.url)}
            renderItem={renderItem}
            keyExtractor={(_, index) => index.toString()}
            estimatedItemSize={300}
            horizontal
            pagingEnabled
            showsHorizontalScrollIndicator={false}
            initialScrollIndex={currentImageIndex}
            overrideItemLayout={getItemLayout}
            onScroll={(event) => {
              const contentOffset = event.nativeEvent.contentOffset.x;
              const imageWidth = event.nativeEvent.layoutMeasurement.width;
              const newIndex = Math.round(contentOffset / imageWidth);
              setCurrentImageIndex(newIndex);

              if (imageUrls?.length > 1) {
                handleOnScroll(event);
              }
            }}
          />
        )}

        {imageUrls?.length > 1 && (
          <Pagination data={imageUrls} scrollX={scrollX} index={currentImageIndex} />
        )}

        <XStack
          onPress={onClose}
          position="absolute"
          top={Platform.OS === 'ios' ? 44 : 10}
          right={Platform.OS === 'ios' ? 20 : 10}
          zIndex={1}
        >
          <X color={'#FFF'} size={28} />
        </XStack>
      </View>
    </Modal>
  );
}
